import { render, staticRenderFns } from "./createBulkPromotion.vue?vue&type=template&id=6c03c01e&scoped=true&"
import script from "./createBulkPromotion.vue?vue&type=script&lang=js&"
export * from "./createBulkPromotion.vue?vue&type=script&lang=js&"
import style0 from "./createBulkPromotion.vue?vue&type=style&index=0&id=6c03c01e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c03c01e",
  null
  
)

export default component.exports